import React, { useState, useEffect } from 'react';
import { 
    Card, 
    Statistic, 
    Row, 
    Col, 
    List, 
    Typography, 
    Tag,
    Space
} from 'antd';
import { 
    CheckCircleOutlined, 
    InfoCircleOutlined
} from '@ant-design/icons';
import { getFieldMappings, getMappingStats } from '../../services/fieldMatchingService';

const { Title, Text } = Typography;

const SyncPanel = ({ customFields = [] }) => {
    const [stats, setStats] = useState({});
    const [mappings, setMappings] = useState(new Map());

    useEffect(() => {
        updateData();
    }, [customFields]);

    const updateData = () => {
        try {
            setStats(getMappingStats(customFields));
            setMappings(getFieldMappings(customFields));
        } catch (error) {
            console.error('Ошибка обновления данных панели синхронизации:', error);
        }
    };

    
    const mappingsList = Array.from(mappings.values()).map(mapping => ({
        customField: mapping.customField,
        amoField: mapping.amoField,
        compatible: mapping.compatible
    }));

    return (
        <Card title="Синхронизация с AMO" style={{ marginBottom: 20 }}>
            <Row gutter={16} style={{ marginBottom: 20 }}>
                <Col span={12}>
                    <Statistic
                        title="Всего полей"
                        value={stats.total || 0}
                        prefix={<InfoCircleOutlined />}
                    />
                </Col>
                <Col span={12}>
                    <Statistic
                        title="Сопоставлено"
                        value={stats.mapped || 0}
                        prefix={<CheckCircleOutlined />}
                        valueStyle={{ color: '#52c41a' }}
                    />
                </Col>
            </Row>

            {mappingsList.length > 0 && (
                <>
                    <Title level={5}>Сопоставленные поля:</Title>
                    <List
                        dataSource={mappingsList}
                        renderItem={mapping => (
                            <List.Item>
                                <Space direction="vertical" style={{ width: '100%' }}>
                                    <Space>
                                        <Text strong>{mapping.customField.name}</Text>
                                        <Text type="secondary">→</Text>
                                        <Text>{mapping.amoField.name}</Text>
                                        <Tag color="success">
                                            {mapping.amoField.type}
                                        </Tag>
                                    </Space>
                                </Space>
                            </List.Item>
                        )}
                    />
                </>
            )}
        </Card>
    );
};

export default SyncPanel; 